import { Component, Input, OnInit, ViewChild } from '@angular/core';
// import { BarcodeScanner, BarcodeScannerOptions } from '@awesome-cordova-plugins/barcode-scanner/ngx';
import { BarcodeScanner } from '@capacitor-community/barcode-scanner';
import { ContentService } from '../../services/content.service';
import { Router } from '@angular/router';
import { AlertController, IonModal } from '@ionic/angular';
import { ProfileService } from '../../services/profile.service';
import { ThemeService } from '../../services/theme.service';
import { Benefit } from '../../models/benefit';

@Component({
  selector: 'app-searcher',
  templateUrl: './searcher.component.html',
  styleUrls: ['./searcher.component.scss'],
})
export class SearcherComponent implements OnInit {

  @Input () value: string;

  scannedData: any;
  onSearch = false;
  searchResults = [];
  searchInFocus = false;

  @Input() placeholder: string;

  // Modals

  @ViewChild('modal1') modal1: IonModal;
  @ViewChild('modal2') modal2: IonModal;
  @ViewChild('CantConfirm') CantConfirm: IonModal;
  @ViewChild('modal5') modal5: IonModal;
  @ViewChild('modalBeneficios') modalBeneficios: IonModal;
  @ViewChild('modalBeneficiosOk') modalBeneficiosOk: IonModal;
  @ViewChild('modalBeneficiosExpirado') modalBeneficiosExpirado: IonModal;

  eventName = '';
  userIdentity: string = '';
  benefit: Benefit;

  result = null;
  scanActive = false;

  constructor(
    // private barcodeScanner: BarcodeScanner,
    private contentService: ContentService,
    public router: Router,
    public profileService: ProfileService,
    public themeService: ThemeService,
    private alertController: AlertController
  ) { console.log( this.value ) }

  ngOnInit() {

    // setTimeout(() => {
    //   this.CantConfirm.present();
    // }, 2000);

    if ( this.profileService.isAuthenticated() ) {
      this.userIdentity = this.profileService.profile.firstName.charAt(0) + this.profileService.profile.lastName.charAt(0) + this.profileService.profile.id;
    }
  }

  ionViewDidEnter() {
    BarcodeScanner.prepare();
  }
  
  search(e) {
    const key = e.target.value;

    if ( key.length <= 3 ) {
      this.searchResults = [];
      this.onSearch = false;
      return;
    }
    if ( key.length > 3 ) {
      console.log(e.target.value);

      this.contentService.search( key ).subscribe( (resp: any) => {
        this.onSearch = true;
        this.searchResults = resp;
        console.log( this.searchResults )
      })
    }
  }

  cleanSearch(){
    this.onSearch = false;    
  }

  async checkPermissionCamera() {
    return new Promise( async (resolve, reject) => {
      const status = await BarcodeScanner.checkPermission({ force: true });

      if ( status.granted) {
        resolve(true);
      } else if (status.denied) {
        const alert = await this.alertController.create({
          header: 'Se necesitan permisos',
          message: 'Por favor conceda permisos de camera',
          buttons: [
            {
              text: 'No',
              role: 'cancel'
            },
            {
              text: 'Abrir configuraciones',
              handler: () => {
                BarcodeScanner.openAppSettings();
                resolve(false);
              }
            }
          ]
        })
      } else {
        resolve(false)
      }
    })
  }

  stopScanner() {
    BarcodeScanner.stopScan();
    this.scanActive = false;
  }

  async qr() {
    const btnCancel = document.querySelector<HTMLElement>('.btn-scanner-inactive');
    const qrBox = document.querySelector<HTMLElement>('.qr-box');
    
      // Check camera permission
      // This is just a simple example, check out the better checks below
      
      const allowed = this.checkPermissionCamera();
      if ( allowed ) {
        document.querySelector('ion-router-outlet').classList.add('scanner-active');
        document.querySelector('ion-spinner').classList.add('scanner-active');
        btnCancel.style.display = 'block';
        qrBox.style.display = 'block';
        const result = await BarcodeScanner.startScan(); // start scanning and wait for a result
        console.log( result )
        if ( result.hasContent ) {
          this.result = result.content;
          this.scanActive = false;
          document.querySelector('ion-router-outlet').classList.remove('scanner-active');
          document.querySelector('ion-spinner').classList.remove('scanner-active');
          btnCancel.style.display = 'none';
          qrBox.style.display = 'none';

            console.log('Barcode data', JSON.parse(result.content)); 
            this.scannedData = JSON.parse(result.content);

            if ( this.scannedData.benefitId ) {
              this.contentService.getBenefit(this.scannedData.benefitId)
                  .subscribe( (benefit: Benefit) => {
                    console.log(benefit)

                    this.benefit = benefit;
                    if ( benefit.expired ) {
                      this.modalBeneficiosExpirado.present();
                    }else {
                      this.profileService.isAuthenticated() ? this.modalBeneficios.present() : this.modal5.present();
                    }
                  })
            } else {
              this.profileService.isAuthenticated() ? this.modal1.present() : this.modal5.present();
            }
        }
      }
  }

  goToPlaces( placeId ) {
    this.router.navigate(['/navigator/results-place', placeId])
  }

  goToTags( tagId, tagName ) {
    this.router.navigate(['/navigator/results', tagId, tagName])
  }

  searchFocus(){
    // this.router.navigate(['/navigator/results']);
    this.searchInFocus = true;
  }
  searchBlur(){

    this.searchInFocus = false;
  }

  goToSearch() {
    this.router.navigate(['/navigator/search-page']);    
  }

  confirm() {
    this.modal1.dismiss();
    
    const opt = {
      "profileId": this.profileService.profile.id,
      "scheduleId": this.scannedData.scheduleId,
    }

    this.contentService.confirm( opt )
        .subscribe( resp => {
          console.log(resp) 
          this.modal2.present();
        },
        error => {
          console.log(error)
          this.CantConfirm.present();
        })
  }

  confirmBeneficios() {
    this.modalBeneficios.dismiss();

    this.contentService.setProfileBenefit( this.scannedData.benefitId, this.profileService.profile.id, this.scannedData.placeId )
        .subscribe( resp => {
          console.log(resp) 
          this.modalBeneficiosOk.present();
        },
        error => {
          console.log(error)
          this.modalBeneficiosExpirado.present();
        })
  }

  closeModals(dialog:string) {
    if( dialog === "confirm") {
      this.modal1.dismiss();
      this.modal5.dismiss();
    } else if ( dialog === 'ok' ) {
      this.modal2.dismiss();
    } else if ( dialog === 'ok-cant' ) {
      this.CantConfirm.dismiss();
    } else if ( dialog === 'confirm-beneficios' ) { 
      this.modalBeneficios.dismiss();
    } else if ( dialog === 'confirm-beneficios-ok' ) { 
      this.modalBeneficiosOk.dismiss();
    } else if ( dialog === 'confirm-beneficios-expirado' ) { 
      this.modalBeneficiosExpirado.dismiss();
    // } else {
    //   this.CantConfirm.dismiss();
    }
  }

  signIn() {
    this.modal5.dismiss();
    this.profileService.signIn()
  }

  ionViewWillLeave() {
    BarcodeScanner.stopScan();
  }
}
